export const seoRouteMap = {
  "/": { endpoint: "https://carboncro.hr/?rest_route=/wp/v2/pages&slug=pocetna" },
  "/pojasevi": { endpoint: "https://carboncro.hr/?rest_route=/wp/v2/pages&slug=pojasevi" },
  "/dizajnvolana": { endpoint: "https://carboncro.hr/?rest_route=/wp/v2/pages&slug=dizajn-volana" },
  "/galerijapage": { endpoint: "https://carboncro.hr/?rest_route=/wp/v2/pages&slug=galerija" },
};